import React from 'react';
import Img from 'gatsby-image';

const BACKGROUND_STYLE = {
  position: 'absolute',
  top: '0px',
  left: '0px',
  height: '100%',
  width: '100%',
  pointerEvents: 'none',
  opacity: 0.15,
};

export default class RegistrationWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.register = this.register.bind(this);

    // pass form a registration hook
    React.Children.toArray(props.children).some(child => addPropToForm(child, this.register));

    this.state = { isRegistered: false };
  }

  register() {
    this.setState({ isRegistered: true });
  }

  render() {
    const { isRegistered } = this.state;
    const { children, className = '', backgroundImageSource } = this.props;
    const backgroundImage = backgroundImageSource ? (
      <Img fluid={backgroundImageSource} style={BACKGROUND_STYLE} />
    ) : null;

    if (isRegistered) {
      return <div>Already registered</div>;
    }

    return (
      <main className={className}>
        {backgroundImage}
        {children}
      </main>
    );
  }
}

function addPropToForm(component, fn) {
  // base case
  if (component && component.type && component.type.name === 'Form') {
    // console.log('Found the target component, do stuff here...');
    component = React.cloneElement(component, { toggleRegistration: fn });
    // component.props.toggleRegistration = fn;
    // console.log(component);
    return true;
  }

  if (component.props) {
    const { children } = component.props || {};
    return React.Children.toArray(children).some(child => addPropToForm(child, fn));
  }

  return false;
}
